<app-login-header></app-login-header>

<div class="container-fluid login-wrapper py-4" style="height: auto;">
  <div class="row justify-content-center">
    <div class="col-lg-10 col-md-10 col-sm-12">
      <div class="card">
        <div class="card-header bg-light">
          <h5 class="card-title mb-0">
            About Us
          </h5>
        </div>

        <div class="card-body">
          <p class="mb-3">The Pollution Control Board has been established as a regulatory authority for implementing various pollution control laws.
            The board is committed to provide pollution free environment to the people of state.
            The Board has undertaken various studies of underground water, soil and air to take remedial steps to control pollution.</p>

          <p class="mb-0">Under Section 4 of the Water (Prevention and Control of Pollution) Act, 1974 and Section 6 of the Air (Prevention and Control of Pollution) Act, 1981 the Pollution Control Board (PCB) is empowered to perform the functions of the State Pollution Control Board for all Union Territories.
            Pollution Control Board (PCB) is empowered to perform the functions of the State Pollution Control Board for all Union Territories. However, Section 4(4) of the Water (Prevention and Control of Pollution) Act, 1974 and Section 6 of the Air (Prevention and Control of Pollution) Act, 1981 provides that PCB may delegate all or any of its powers and functions of a State Board in a UT under the said Acts to such person or body of persons as the Central Government may specify.</p>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
